import type { Banner } from '../types';

interface Props {
  banner: Banner;
  contextLabel?: string | null;
  verificationStatus?: string | null;
  attainmentPct?: number | null;
}

export function StatusBanner({ banner, contextLabel, verificationStatus, attainmentPct }: Props) {
  return (
    <header className="status-banner">
      <div className="banner-item">
        <label>Selected Scenario</label>
        <strong>{banner.selected_scenario}</strong>
      </div>
      <div className="banner-item">
        <label>PM GDP Target</label>
        <strong>{banner.pm_target.toFixed(1)}%</strong>
      </div>
      <div className="banner-item">
        <label>Current Verified GDP</label>
        <strong>{banner.current_verified_gdp?.toFixed(1) ?? '—'}%</strong>
        <div className="banner-meta">
          {banner.current_observation_period} · {banner.current_source_agency}
        </div>
      </div>
      <div className="banner-item">
        <label>Macro Gap to Target</label>
        <strong>{banner.current_gap_to_target_pp != null ? `${banner.current_gap_to_target_pp.toFixed(1)} pp` : '—'}</strong>
      </div>
      <div className="banner-item">
        <label>Selected Scenario Simulation</label>
        <strong>{banner.selected_simulated_gdp.toFixed(2)}%</strong>
        <div className="banner-meta">Scenario gap: {banner.selected_gap_to_target_pp.toFixed(2)} pp</div>
      </div>
      <div className="banner-item">
        <label>Verification Status</label>
        <strong style={{ fontSize: '0.9rem' }}>{verificationStatus ?? 'Loading…'}</strong>
        {attainmentPct != null && <div className="banner-meta">Overall attainment: {(attainmentPct * 100).toFixed(0)}%</div>}
        {contextLabel && <div className="banner-meta">{contextLabel}</div>}
      </div>
    </header>
  );
}
